import { Component, inject, OnInit } from '@angular/core';
import { AuthService, ToastService } from 'libs/core/src/public-api';
import { FormGroup } from '@angular/forms';
import {
  FormFactoryComponent,
  FormFactoryService,
} from 'ngx-dynamic-forms-factory';
import { LoginFieldsService } from '../../services/login-fields.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { ButtonComponent } from 'libs/ui/src/public-api';

@Component({
  selector: 'lib-reset-password',
  imports: [FormFactoryComponent, TranslateModule, RouterLink, ButtonComponent],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  authService = inject(AuthService);
  route = inject(ActivatedRoute);
  form!: FormGroup;
  formFactory = inject(FormFactoryService);
  fieldsService = inject(LoginFieldsService);
  toastService = inject(ToastService);

  ngOnInit(): void {
    this.form = this.formFactory.createForm(
      this.fieldsService.resetPasswordFields,
    );
    this.form.patchValue({
      email: this.route.snapshot.queryParams['email'],
    });
  }

  onResetPassword() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.authService.resetPassword({
      ...this.form.getRawValue(),
      token: this.route.snapshot.queryParams['token'],
    });
  }
}
